import React from 'react';
import TeachingActivitiesKeyStageFilter from './filters/TeachingActivitiesKeyStageFilter';
import TeachingActivitiesSubjectFilter from './filters/TeachingActivitiesSubjectFilter';
import TeachingActivitiesPeriodFilter from './filters/TeachingActivitiesPeriodFilter';

export default function TeachingActivitiesSearchFilters() {
  return (
    <>
      <TeachingActivitiesKeyStageFilter />
      <TeachingActivitiesSubjectFilter />
      <TeachingActivitiesPeriodFilter />
    </>
  );
}
